export default __webpack_public_path__ + "static/media/yt_nibiru-ep2.ae1a49d8.jpg";